jQuery(document).ready(function(){


  
//   jQuery('.collection_item_cus').sort(function (a, b) {
		
//       var contentA =parseInt( jQuery(a).attr('data-surname'));
//       var contentB =parseInt( jQuery(b).attr('data-surname'));
//       console.log(contentB);
//       console.log(contentA);
//       return (contentA < contentB) ? -1 : (contentA > contentB) ? 1 : 0;
//    });
  
  jQuery("#sort-collections>.collection_item_cus").sort(function(a, b) { 
    var contentA = jQuery(a).attr('data-surname'); 
//     console.log(contentA);
    var contentB = jQuery(b).attr('data-surname'); 
    return (contentA < contentB) ? -1 : (contentA > contentB) ? 1 : 0; 
  }).appendTo(jQuery("#sort-collections"));
  
//   scroll loadding on collection page
  
//   var hieghtThreshold = jQuery(".btn-loading").offset().top;
//   var hieghtThreshold_end  = jQuery(".btn-loading").offset().top +jQuery(".btn-loading").height() ;
//   var check = true;
//   var number = jQuery('.list-product-collection').attr('data-view');
//   jQuery(window).on('load',function(){
//     var count = jQuery('.list-product-collection .product-collection').length;
//     console.log(count);
//     if(count < number){
//       jQuery('.btn-loading').addClass('hide');
//       jQuery(".btn-end").addClass('show');
//     }
//   });
//   jQuery(window).scroll(function() {
//     var scroll = jQuery(window).scrollTop();
//     if(!check){      
//       return false;
//     }
//     if (scroll >= hieghtThreshold - 300 ) {
//       check = false;
      
//       var k = 0;      
//       jQuery('.product-collection').each(function(e,i){
//           if(jQuery(this).hasClass('hide')){
//             if(k<number){
//               jQuery(this).addClass('show');
//               jQuery(this).removeClass('hide');
//               hieghtThreshold = jQuery(".btn-loading").offset().top;
//             }else{
//               check = true;
//             }
//             k++; 
//           }
//         });
//       if(k <= number){
//         jQuery('.btn-loading').addClass('hide');
//         jQuery(".btn-end").addClass('show');
//       }
//     }
//   });
  var number = jQuery('.list-product-collection').attr('data-view');
  jQuery(window).on('load',function(){
    var count = jQuery('.list-product-collection .productcollection').length;
//     console.log(count);
    if(count < number){
      jQuery('.btn-loading').addClass('hide');
      jQuery(".btn-end").addClass('show');
    }
  });
  
  jQuery('.btn-loading').on('click',function(){
    var k = 0; 
    jQuery(this).find('span').text('Loading');
    jQuery(this).find('span').css('padding-left','10px');	
    jQuery(this).find('i').show();
    	
      setTimeout(function(){ 
      	jQuery('.productcollection').each(function(e,i){
          if(jQuery(this).hasClass('hide')){
            if(k<number){
              jQuery(this).addClass('show');
              jQuery(this).removeClass('hide');
            }else{
              
            }
            k++; 
          }
        });
        jQuery('.btn-loading').find('span').text('Load More');
        jQuery(this).find('span').css('padding-left','0px');
        jQuery('.btn-loading').find('i').hide();
        if(k <= number){
      jQuery('.btn-loading').addClass('hide');
      jQuery(".btn-end").addClass('show');
    }
      },2000);
    
    
    
    
  });
  
  jQuery(window).on('load',function(){
    jQuery('.productcollection').each(function(){
      var width = jQuery(this).find('.product-collection__image').width();
      console.log(width);
      jQuery(this).find('.product-collection__image').height(width);
    });
    
  });
  
});